import React from 'react';

import SearchSort, { TrackSort } from '../../search-filter/components/search-sort';
import { withError } from '../../shared/components/error-boundary';
import Dropdown from '../../ui/components/dropdown';

class VWASort extends React.PureComponent {

    sortChange = (setSort, options) => (value) => {
        const { field, order } = options[value] || {};
        setSort({ field, order });
    }

    render(){
        const { sortOptions } = this.props;
        return (
            <TrackSort>
                {({ trackSort }) => (
                    <SearchSort options={sortOptions} onSort={trackSort}>
                        {
                            ({ options, value, setSort }) => {
                                return (<Dropdown 
                                    options={options} 
                                    onChange={this.sortChange(setSort, options)} 
                                    label={'Sort by'} 
                                    value={value} />)
                            }
                        }
                    </SearchSort>
                )}
            </TrackSort>
        );
    }
}

export default withError(VWASort);
